import { studentDashboardActions } from 'StudentDashboardSlice';
import { type FC, memo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { type ProjectContentBoxProps } from './ProjectContentBox.types';
import { ProjectContentBoxPresentation } from './ProjectContentBox';
import { useProjectImage } from './useProjectImage';

const ProjectDirectLinkBoxComponent: FC<
    Pick<ProjectContentBoxProps, 'project' | 'fullWidth' | 'padding' | 'titleSize'>
> = ({ project, fullWidth, padding = '3.5', titleSize = 'base' }) => {
    const imageSrc = useProjectImage();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handlePress = useCallback(() => {
        dispatch(
            studentDashboardActions.setPendingFocusedProjectRequirementIdentifier({
                requirementIdentifier: project.requirementIdentifier,
            }),
        );
        dispatch(studentDashboardActions.setMobileDrawerShouldHide());
        navigate('/dashboard/currently-studying');
    }, [project, navigate, dispatch]);

    return (
        <ProjectContentBoxPresentation
            title={project.title}
            src={imageSrc}
            fullWidth={fullWidth}
            padding={padding}
            titleSize={titleSize}
            projectRequirementIdentifier={project.requirementIdentifier}
            itemId={project.id}
            initiallyExpanded={false}
            expandedContent={null}
            onPress={handlePress}
        />
    );
};

export const ProjectDirectLinkBox = memo(ProjectDirectLinkBoxComponent) as typeof ProjectDirectLinkBoxComponent;
